var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #666a70;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10235",
    "data-name": "Group 10235",
    transform: "translate(-54 -544)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18705",
    "data-name": "Rectangle 18705",
    className: "cls-1",
    width: 30,
    height: 30,
    rx: 6,
    transform: "translate(54 544)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "upload_icon",
    "data-name": "upload icon",
    transform: "translate(-35 197.2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2842",
    "data-name": "Rectangle 2842",
    className: "cls-2",
    width: 0.643,
    height: 3.996,
    transform: "translate(103.679 365.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6106",
    "data-name": "Path 6106",
    className: "cls-2",
    d: "M46.758,68.595c0-.05.008-.1.008-.15A4.784,4.784,0,0,0,42.073,63.6a4.634,4.634,0,0,0-4.195,2.76,2.3,2.3,0,0,0-1.077-.266,2.509,2.509,0,0,0-2.367,2.164A3.8,3.8,0,0,0,32,71.85,3.682,3.682,0,0,0,35.6,75.6h5.079V69.519l-2.2,2.268-.466-.483,2.993-3.093L44,71.3l-.474.483-2.206-2.268V75.6h5.384A3.387,3.387,0,0,0,50,72.158,3.447,3.447,0,0,0,46.758,68.595Z",
    transform: "translate(63 290.2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIconGrey);
export default __webpack_public_path__ + "static/media/uploadIconGrey.7b1d2d771553920e855d298fb913aa3f.svg";
export { ForwardRef as ReactComponent };